import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pinterest = defineConnector({
  identifier: "pinterest",
  name: "Pinterest",
  tagLine: "Visual discovery and bookmarking platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.pinterest\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get a Pinterest access token",
      items: [
        {
          kind: "markdown",
          content:
            "Create an app at the [Pinterest Developer Portal](https://developers.pinterest.com/apps/) and complete the OAuth flow to obtain an access token.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.pinterest.com/v5/user_account",
  },
});
